import { AppRootStateType } from 'state/store';

export const contactSelect = (state: AppRootStateType) => state.contacts.contactInfo;
